import { combineReducers } from 'redux';
import users from './users';
import tasks from './tasks';
import clients from './clients';
import auth from './auth';
import executionLog from './executionLogs';
import notifications from './notification';
import jobs from './jobs';

const rootReducer = combineReducers({
  users,
  clients,
  tasks,
  executionLog,
  auth,
  notifications,
  jobs,
});

export default rootReducer;
